import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useQuickTopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();

  const openTopup = () => setIsOpen(true);

  const onSuccess = () => {
    setIsOpen(false);
    toast.success('Top-up successful! Your balance has been updated.');
    queryClient.invalidateQueries({ queryKey: ['payment-balance'] });
  };

  return { isOpen, setIsOpen, openTopup, onSuccess };
};
